import React from 'react';

import StartTradingFtr from '@appComponents/bb-startTradingFooter';
import { CoinsList } from '@appComponents/bb-coinlistView';
import { SEO } from '@components';

import star from '@img/star.svg';

const titleText = 'About Bitbns - Cryptocurrency Exchange in India';
const description =
	'Bitbns is a cryptocurrency exchange in India. Our cryptocurrency exchange / trading platform allow users to trade Bitcoin(BTC) in INR. Upcoming currency in bitbns : Etheruem (ETH), Litecoin (LTC) Bitcoin Cash (BCH)';
const url = 'https://bitbns.com/about-us/';

const AboutUs = () => (
	<div className="bg-white">
		<SEO title={titleText} url={url} description={description} />

		<div className="bg-primary text-white py-8">
			<div className="container">
				<h1 className="font-bold text-center my-0 text-3xl">
					About Us
				</h1>
			</div>
		</div>
		<div className="bg-white px-4">
			<div className="container py-16">
				<div className="mx-auto leading-normal max-w-6xl">
					<h2 className="font-bold text-2xl my-8 text-center">
						Who We Are
					</h2>

					<p className="my-4">
						Our founding members are young and enthusiastic adopters
						of crypto currencies, all of whom graduated from IIT.
						Before we started Bitbns, we have created multiple
						products that have helped consumers in commerce decision
						making.
						{/* we
								created <b>Buyhatke</b>, a tool to help you shop
								online. We also introduced more products for
								businesses. */}
					</p>
					<p className="mt-4">
						In late 2017, we decided to start a crypto-currency
						exchange. To give people a smooth entry into the world
						of crypto, we gave importance to ease of use, security,
						and customer support right from the beginning. Bitbns
						went live on December 14, 2017.
					</p>
					<p className="mt-4">
						In just a few months, our focus proved right.
					</p>
				</div>
			</div>
		</div>

		<div className="container py-16">
			<div className="mx-auto mb-16 max-w-6xl">
				<div className="mx-auto mb-16 leading-normal max-w-6xl">
					<h3 className="font-bold text-2xl my-8 text-center">
						What We Believe
					</h3>

					<p className="my-4">
						<img
							src={star.src}
							alt="*"
							height="28"
							width="28"
							className="inline-block align-middle mr-2"
						/>
						Cryptocurrencies and the underlying blockchain
						technology are the <b>future of money</b>.
					</p>

					<p className="my-4">
						<img
							src={star.src}
							alt="*"
							height="28"
							width="28"
							className="inline-block align-middle mr-2"
						/>
						Open, transparent and <b>clear communication</b> with
						our users.
					</p>

					<p className="my-4">
						<img
							src={star.src}
							alt="*"
							height="28"
							width="28"
							className="inline-block align-middle mr-2"
						/>
						Simple, aesthetic, and <b>easy to use interface</b>
					</p>
					<p className="my-4">
						<img
							src={star.src}
							alt="*"
							height="28"
							width="28"
							className="inline-block align-middle mr-2"
						/>
						Crypto-currencies must be accessible to everyone. Never
						for just a select few.
					</p>
					<p className="my-4">
						<img
							src={star.src}
							alt="*"
							height="28"
							width="28"
							className="inline-block align-middle mr-2"
						/>
						We support not just established currencies like Bitcoin,
						but also niche altcoins with real benefits.
					</p>
					<p className="my-4">
						<img
							src={star.src}
							alt="*"
							height="28"
							width="28"
							className="inline-block align-middle mr-2"
						/>
						Responsive and <b>immediate customer support</b>
					</p>
				</div>
			</div>
		</div>

		<StartTradingFtr />
		<CoinsList buy price singleLine />
	</div>
);

export default AboutUs;
